import axios from 'axios';
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const token = localStorage.getItem('token');


export const addBlog = async (formData) => {
  console.log(formData+"Form Data")
    try {
      const response = await fetch(`${BACKEND}/addblogs`, {
        method: 'POST',
        body: formData,
      });
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error adding blog:', error);
      throw error;
    }
  };

  export const fetchBlogs = async () => {
    try {
      const response = await axios.get(`${BACKEND}/getblogs`,
        {headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
        },}
      );
      return response.data; // Return the blog data
    } catch (error) {
      console.error('Error fetching blogs:', error);
      throw error; // Throw error to handle it in the component
    }
  };
  
  export const togglePublish = async (blogId) => {
    try {
      const response = await fetch(`${BACKEND}/${blogId}/toggle`, {
        method: 'PATCH',
      });
      if (!response.ok) {
        throw new Error('Failed to update blog');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error updating blog:', error);
      throw error;
    }
  };

  export const deleteBlog = async (blogId) => {
    try {
      const response = await fetch(`${BACKEND}/${blogId}/deleteBlog`, {
        method: 'DELETE',
      });
      if (!response.ok) {
        throw new Error('Failed to delete blog');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error deleting blog:', error);
      throw error;
    }
  };
  export const updateBlog = async (id, formData) => {
    try {
      const response = await fetch(`${BACKEND}/blogs/${id}`, {
        method: 'PUT',
        body: formData,
      });
      if (!response.ok) {
        throw new Error('Error updating blog');
      }
      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };